import React, {PropsWithChildren, useEffect, useState} from "react";

interface PadeData {
    pdf_url?: string;
    paid_pdf_url?: string;
}

interface PageContextState {
    page: string;
    setPage: (page: string) => void;
    isActivePage: () => boolean;
    isAcceptedSignaturePage: () => boolean;
    isRejectedSignaturePage: () => boolean;
    isPaidPage: () => boolean;
    pageData: PadeData;
    setPageData: (pageData: PadeData) => void;
    isVoidPage: () => boolean;
    isOverduePage: () => boolean;
    isPaymentAcceptedSignaturePage: () => boolean;
    setPaymentAcceptedSignatureMode: (value: boolean) => void;
}


export const PageContext = React.createContext({} as PageContextState);


export const PageProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const [page, setPage] = useState('');
    const [pageData, setPageData] = useState<PadeData>({});
    const [paymentAcceptedSignatureMode, setPaymentAcceptedSignatureMode] = useState<boolean>(false);


    useEffect(() => {
        setPage((window as any).PAGE_DATA.status);
        setPageData((window as any).PAGE_DATA.data || {});
    }, [false])

    const isActivePage = () => {
        return page === 'active' || !page;
    }

    const isPaidPage = () => {
        return page === 'invoice-paid';
    }

    const isAcceptedSignaturePage = () => {
        return page === 'invoice-accepted';
    }

    const isRejectedSignaturePage = () => {
        return page === 'invoice-rejected';
    }

    const isOverduePage = () => {
        return page === 'invoice-overdue';
    }

    const isVoidPage = () => {
        return page === 'invoice-void';
    }

    const isPaymentAcceptedSignaturePage = () => {
        return paymentAcceptedSignatureMode;
    }

    return <PageContext.Provider
        value={{
            page,
            setPage,
            isActivePage,
            isAcceptedSignaturePage,
            isRejectedSignaturePage,
            isPaidPage,
            pageData,
            setPageData,
            isOverduePage,
            isVoidPage,
            isPaymentAcceptedSignaturePage,
            setPaymentAcceptedSignatureMode
        }}>
        {children}
    </PageContext.Provider>
}
